<template>
    <div class="animate-box">
        <!--page tools-->
        <template v-if="turn_off_content_pagetools!=1">
            <template v-if="((main_content['id_element']==='001' || main_content['id_element']=='012' || main_content['id_element']=='024' || main_content['id_element']=='058') && (company_data['id_customizations']!='543' && company_data['id_customizations']!='570' ))">
                <page-tools v-if="( copyright_type=='' || copyright_type == 'Public' || copyright_type == 'public' || copyright_type == 'WPO' || copyright_type == 'wpo')"/>
                <p v-else v-html="languageData['noemail']" class="col-md-12 col-sm-12 archives"></p>
            </template>
        </template>

        <div class="desc main-cont">            
            <h1 id="top" v-html="main_content['title']" ></h1>
            <p v-if="returnmsg==''" v-html="main_content['body_combine']" @click.capture="handleClick"></p>
            <p v-else v-html="returnmsg"></p>
            <hr/>
            <p v-if="returnmsg==''" v-html="main_content['source']"></p>
            <template v-if="this.link_to!=''">
            <span v-if="main_content['link_to_langId']=='003' || main_content['link_to_langId'] == '056' || main_content['link_to_langId'] == '055'">
                <router-link :to="'/content/'+this.link_to">Chasque aqu&iacute; para la versi&oacute;n Espa&ntilde;ola.</router-link>
            </span>
            <span v-else-if ="main_content['link_to_langId']=='001' || main_content['link_to_langId'] == '059' || main_content['link_to_langId'] == '053' || main_content['link_to_langId'] == '054' || main_content['link_to_langId'] == '039' || main_content['link_to_langId'] == '050'">
                <router-link :to="'/content/'+this.link_to" >Click here for English version</router-link>
            </span>
            <span v-else-if ="main_content['link_to_langId']=='051' || main_content['link_to_langId'] == '002'">
                <router-link :to="'/content/'+this.link_to" >Cliquez ici pour la version fran&ccedil;aise.</router-link>
            </span>
            </template>
            <p v-if="star_rating==0 && returnmsg==''" >
                <!--<label>{{languageData['rating']}}</label>-->
                <iframe :title="languageData['starDescription']" :src="CONTENT_DOMAIN+'/new_eesite_rating.php?id_language='+this.$store.state.companyData['id_language']+'&id_cr='+content_id+'&id_country='+this.$store.state.companyData['id_country']+'&id_company='+this.$store.state.companyData['id_company']" width="100%" height="150px" frameborder="0" allowfullscreen="" ></iframe>
                
            </p>
        </div>
 
      <link rel="stylesheet" v-bind:href="this.CONTENT_DOMAIN+'/js/ableplayer_megazine/build/ableplayer.min.css'" Content-Type="text/css"/>  
    </div>


</template>

<script>
import axios from 'axios';
import PageTools from '@/components/ThemeMegazine/pages/partialsCommon/PageTools';

export default {
    name: 'mainContent',
    data(){
        return{
            main_content:[],
            star_rating:'',
            turn_off_content_pagetools:'',
            copyright_type:'',
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN ,
            FORM_ACTION_DOMAIN:this.$store.state.FORM_ACTION_DOMAIN,
            LOCAL_HOST:this.$store.state.LOCAL_HOST ,
            company_data:[],
            content_id :'' , returnmsg:'', link_to:'',
            someValue:''             
        };
        
    },
    components:{
        PageTools
    },
    watch: { 
        // call again the method if the route changes
        '$route'(){
            this.showContent(this.$route.params.id)
            window.scrollTo(0,0); 
        }        
        
    },
    computed:{
        languageData(){return this.$store.state.languageData;},
        themelogic(){return this.$store.state.themeLogic;}
    },
    mounted :function(){
        this.showContent(this.$route.params.id),
        this.getCompanyData()
       //console.log(this.main_content)
	},
	methods:{
      showContent(cr_id){
          this.content_id=cr_id;
          var api_private_key=this.get_api_key_mix('cols');
          axios.get(this.$store.state.apiUrl+'/content_details',{
              params:{
                  id_cr:cr_id,
                  id_company:this.$store.state.companyData['id_company'],
                  id_language:this.$store.state.companyData['id_language'],
                  id_country:this.$store.state.companyData['id_country'],
                  privatekey:api_private_key                  
              }
          })
          .then(response => {              
                response = response.data
                //console.log(response);
                this.main_content = response[0],
                this.copyright_type=this.main_content['copyright_type'];
                //this.$parent.content_ld_flag=false

                this.someValue= this.main_content['title'];
                var test = document.title;
                if(test==""){
                    this.$announcer.set(this.decodeHtmlLang(this.someValue)+' | '+this.$store.state.companyData['name_company']);
                    document.title = this.decodeHtmlLang(this.someValue)+' | '+this.$store.state.companyData['name_company'];
                }
                else{
                    console.log('testtest-',test);
                    this.$announcer.set(this.decodeHtmlLang(test)+' | '+this.decodeHtmlLang(this.someValue)+' | '+this.$store.state.companyData['name_company']);
                    document.title = this.decodeHtmlLang(test)+'  '+this.decodeHtmlLang(this.someValue)+' | '+this.$store.state.companyData['name_company'];
                }
                
                const myElement = document.getElementsByClassName("crumb-no-click")[0];
               
                if(myElement!=undefined){
                    myElement.innerHTML  = this.someValue;
                }

                if(this.main_content['link_to'] != ''){
                    this.link_to = this.main_content['link_to'];
                } else {
                    this.link_to = '';
                }
                
                this.$emit('content_ld_flag_changed');
                
                this.star_rating=this.$store.state.themeLogic.additional_flag.turn_off_star_rating;
                this.turn_off_content_pagetools=this.$store.state.themeLogic.additional_flag.turn_off_content_pagetools;
                this.$nextTick(function () {
                
                })
              
          })
          .catch((error) => {
                this.main_content = [];
                this.customErrorHandler(error.response.status);
          });
      },
      getCompanyData(){        
          var api_private_key=this.get_api_key_mix('cofo')
          axios.get(this.$store.state.apiUrl+'/company_info',{
              params:{
                  id_company:this.$store.state.companyData['id_company'] ,
                  id_language:this.$store.state.companyData['id_language'],
                  id_country:this.$store.state.companyData['id_country'],                    
                  privatekey:api_private_key
                }
            })
          .then(response => {
              response = response.data,
              //console.log(response)
              //console.log('footrnavvvv---'+response[0]['footer_text'])
              this.company_data = response,
              //this.company_data['id_customizations']='540'
                          
              this.$nextTick(function () {
                  
                })          
            })
          .catch((error) => {
              this.company_data = [];
              this.customErrorHandler(error.response.status);
            });
        },

        handleClick(e) {
            if ( (e.target.tagName === 'BUTTON' || e.target.tagName === 'INPUT') && e.target.type === 'submit' ) {
                var actionUrl = e.target.form.action.replace(this.LOCAL_HOST+'/', '');
                actionUrl = actionUrl.replace('content/', '');
                if(actionUrl.includes(".php")){                
                    const config = {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }
                    var serialize = require('form-serialize');
                    let data = serialize(e.target.form, {hash: false, empty: true});
                    data += '&' + e.target.name + '=' + encodeURIComponent( e.target.value ); 
                    data += '&actionVal=' + encodeURIComponent( actionUrl );
                    data += '&id_company='+ this.$store.state.companyData['id_company'];
                    data += '&id_language='+ this.$store.state.companyData['id_language'];
                    data += '&id_country='+ this.$store.state.companyData['id_country'];
                    data += '&name_company='+ this.$store.state.companyData['name_company'];
                    data += '&id_eap='+ this.$store.state.companyData['id_eap'];
                    axios.post(this.FORM_ACTION_DOMAIN+'/new_eesite_forms/dynamicForms.php',data,config)
                    .then(response => {
                        this.returnmsg = response.data
                        //console.log(response);
                        //e.preventDefault();
                    })
                    .catch(() => {
                        //this.returnmsg='Try after sometime'
                    });
                        e.preventDefault();
                }
            }
        }
    }
};
</script>
<style scoped>
.content-top-btm-space{
    padding: 55px 0;
}
/*h2{color: #276d96c7;}*/
@media screen and (max-width: 768px){
    .main-cont{
        margin-right: 1em !important;
    }
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color:#757777;
  opacity: 1; /* Firefox */
}
::-ms-input-placeholder { /* Microsoft Edge */
  color:#757777;
}
.archives {
    width: 98%;
    padding: 1em 1em 1em 1em;
}
.main-cont a {
    text-decoration: underline;
}
</style>
<style>
.main-cont a {
    text-decoration: underline;
}
form#pwfps fieldset {
    width: 100%;
    display: block;
    border: 1px dotted #024179;
    padding: 5px 5px 15px 10px;
    margin-bottom: 20px;
}
form#pwfps legend {
    margin-bottom: 15px;
    padding: 5px 12px;
    background: #eeeeeea8;
    color: #024179;
}
form#pwfps select {
    border: 1px solid #414d59;
    padding-left: 0.2em;
    margin-bottom: .3em;
    background: #fff;
    margin-top: 0px;
    padding: 10px;
}
form#pwfps input {
    padding: 7px;
}
form#pwfps label {
    clear: left;
    display: block;
    float: left;
    width: 200px;
    text-align: right;
    padding-right: 10px;
    margin-top: 8px;
}
table{
    margin: 10px 0 30px 0;
    table-layout: fixed;
    width: 100%;
}

table input {
    margin: 5px;
}

table tr td {
    padding: 10px;
    background: #e8e8e517;
}
table tr th {
    padding: 10px;
    background: #e8e8e517;
}
table td{
    height: 3.0em;
    border-left: solid 2px rgb(220 220 220 / 22%);
    border-right: solid 2px rgb(220 220 220 / 22%);
    border-top: solid 2px rgb(220 220 220 / 22%);
    border-bottom: solid 2px rgb(220 220 220 / 22%);
    /* background-color: rgb(225,225,225);
    text-align: left; */
    font-weight: normal;
    /* color: rgb(80,80,80); */
    font-size: 100%;
}
table th{
    height: 3.0em;
    border-left: solid 2px rgb(220 220 220 / 22%);
    border-right: solid 2px rgb(220 220 220 / 22%);
    border-top: solid 2px rgb(220 220 220 / 22%);
    border-bottom: solid 2px rgb(220 220 220 / 22%);
    /* background-color: rgb(225,225,225);
    text-align: left; */
    font-weight: normal;
    /* color: rgb(80,80,80); */
    font-size: 100%;
}
a.next {
    background: #ECECEC;
    border-radius: 15px;
    padding: 10px 20px;
    display: block;
    font-weight: bold;
    color: #000;
    text-decoration: none;
    text-shadow: 0px 1px 0px #fff;
    border: 1px solid #a7a7a7;
    /*width: 45px;*/
    float: right;
    box-shadow: 0px 2px 1px white inset, 0px -2px 8px white, 0px 2px 5px rgba(0, 0, 0, 0.1), 0px 8px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
}
a.previous {
    background: #ECECEC;
    border-radius: 15px;
    padding: 10px 20px;
    display: block;
    font-weight: bold;
    color: #000;
    text-decoration: none;
    text-shadow: 0px 1px 0px #fff;
    border: 1px solid #a7a7a7;
    /*width: 75px;*/
    float: left;
    box-shadow: 0px 2px 1px white inset, 0px -2px 8px white, 0px 2px 5px rgba(0, 0, 0, 0.1), 0px 8px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
}

</style>